angular.module('app.filters').filter('trustedUrl', ($sce) => {
  'ngInject';
  return (string) => $sce.trustAsResourceUrl(string);
});



// WEBPACK FOOTER //
// ./app/filters/trusted-url.js